import React from "react";
import { AllergiesStackScreenProps } from "../AllergiesNavigator";
import { useAllergies } from "../AllergiesContext";
import { useQueuedPatientUpdate } from "@louise/patients/sync/usePatientSync";
import { transformAllergiesStateToRequest } from "../transformAllergiesStateToRequest";
import {
  BaseCompleteScreen,
  navigateToNextSection,
  getNextSectionButtonLabel,
} from "@louise/medical-history/components/BaseCompleteScreen";
import { useTranslations } from "@src/packages/i18n";

export function AllergiesCompleteScreen({
  navigation,
}: AllergiesStackScreenProps<"AllergiesComplete">) {
  const t = useTranslations();
  const { state } = useAllergies();
  const { mutateAsync: updatePatient, isPending: isUpdatingPatient } =
    useQueuedPatientUpdate();

  const handleFinish = async () => {
    try {
      const payload = transformAllergiesStateToRequest(state);

      await updatePatient(payload);

      navigateToNextSection(navigation, "allergies");
    } catch {}
  };

  return (
    <BaseCompleteScreen
      subtitle={t("med_history.medical.allergies.complete_subtitle")}
      buttonLabel={getNextSectionButtonLabel(t, "allergies")}
      isSubmitting={isUpdatingPatient}
      onFinish={handleFinish}
    />
  );
}

export default AllergiesCompleteScreen;
